import { render, staticRenderFns } from "./ProgrammingBlock.vue?vue&type=template&id=3ad0bff0&"
import script from "./ProgrammingBlock.vue?vue&type=script&lang=js&"
export * from "./ProgrammingBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports